export default __webpack_public_path__ + "static/media/cancelOrderSong.379fad6e.mp3";